export const formatEIN = (value: string | undefined) => {
  if (!value) {
    return value;
  }

  const ein = value.replace(/[^\d]/g, "");

  const einLength = ein.length;

  if (einLength < 3) {
    return ein;
  }

  if (einLength < 9) {
    return `${ein.slice(0, 2)}-${ein.slice(2)}`;
  }

  return `${ein.slice(0, 2)}-${ein.slice(2, 9)}`;
};

export const formatEINSensitiveHidden = (value: string | undefined) => {
  if (!value) {
    return value;
  }

  return formatEIN(value)?.replace(/\d/g, "•");
};